import { SelectOption } from '@globaleris/ui.library'
import { EnumCommodity, EnumTipoSujeto } from '../api'
import { subjectFilterMapper, subjectsListMapper } from '../pages/clients/client.mapper'
import {
  apiGetCUPSBySubjectId,
  apiGetSubjects
} from '../api/Argentia/endpoints/clients/clients.api'
import { ServiceResponse } from '../model/serviceResponse'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../helpers/serviceResponseHelper'

export const fetchSubjects = async (query: string): Promise<SelectOption[]> => {
  const subjectTypeList: EnumTipoSujeto[] = [
    EnumTipoSujeto.ClienteFinal,
    EnumTipoSujeto.ClienteExtendido
  ]
  const isActive: boolean = true
  const commodity: EnumCommodity = EnumCommodity.GasNatural
  return await apiGetSubjects(
    subjectFilterMapper(query, subjectTypeList, isActive, commodity)
  ).then(response => {
    return subjectsListMapper(response)
  })
  // .catch(error => {
  //   return createErrorServiceResponse(error)
  // })
}

export const getCUPSBySubjectId = async (
  subjectID: number
): Promise<ServiceResponse<Record<number, string> | undefined>> => {
  return await apiGetCUPSBySubjectId(subjectID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
